import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminMemberInvoiceService {
  constructor() {
    this.endpoints = createPrefix('/admin', {
      invoices: '/invoices',
    })
  }

  static create() {
    return new AdminMemberInvoiceService()
  }

  async queryMembersInvoice(memberId, params) {
    let servicePath = this.endpoints.invoices()
    servicePath += `/${memberId}/pages`
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async createMemberInvoice(memberId, form) {
    let servicePath = this.endpoints.invoices()
    servicePath += `/${memberId}`
    const { data } = await axios.post(servicePath, { ...form })
    return data
  }

  async cancelMemberInvoicePayment(invoiceNumber) {
    let servicePath = this.endpoints.invoices()
    servicePath += `/${invoiceNumber}/payments/cancellations`
    const { data } = await axios.put(servicePath, {})
    return data
  }

  async acceptMemberInvoicePayment(invoiceNumber) {
    let servicePath = this.endpoints.invoices()
    servicePath += `/${invoiceNumber}/payments`
    const { data } = await axios.put(servicePath)
    return data
  }
}
